import React from 'react';
import './ReviewsTab.css';

const ReviewsTab = () => {
  const handleClick = () => {
    // Add reviews modal or redirect functionality here
    alert('Reviews feature - customize this functionality');
  };

  return (
    <div className="reviews-tab" onClick={handleClick}>
      <div className="reviews-text">Testimonials</div>
    </div>
  );
};

export default ReviewsTab;

